import React from "react";
import PropTypes from "prop-types";
import {
  SFCheckboxUnchecked,
  SFCheckboxChecked,
  SFCheckboxIdeterminateIcon,
} from "../icons";
import CustomCheckbox from "./customCheckbox";
import { PROPS as IconProps } from "../icons/props";

const SFCheckbox = ({
  checked = false,
  disabled = false,
  required = false,
  label,
  labelPlacement = "end",
  onChange,
  indeterminate = false,
  size = "medium",
  defaultChecked,
}) => {
  return (
    <CustomCheckbox
      {...(typeof defaultChecked === "undefined" && { checked })}
      checked={checked}
      disabled={disabled}
      defaultChecked={defaultChecked}
      label={label}
      required={required}
      labelPlacement={labelPlacement}
      onChange={onChange}
      indeterminate={indeterminate}
      indeterminateIcon={
        <SFCheckboxIdeterminateIcon size={size} color={"blue400"} />
      }
      checkedIcon={<SFCheckboxChecked size={size} color={"blue400"} />}
      icon={<SFCheckboxUnchecked size={size} color={"grey500"} />}
    />
  );
};

SFCheckbox.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /**
   * The position of the label.
   */
  labelPlacement: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  /**
   * Callback fired when the state is changed.
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: PropTypes.bool,
  /**
   * The size of the component.
   */
  size: IconProps.size,
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
};

export default SFCheckbox;
